<h1 mat-dialog-title>New Service Route</h1>
<div mat-dialog-content class="body-content">
  <form [formGroup]="form" class="svc-form">
    <div class="drawer-row">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        floatLabel="always">
        <mat-label>Route ID</mat-label>
        <input
          name="routeId"
          cdkFocusInitial
          matInput
          placeholder="Route ID"
          aria-label="Route ID"
          formControlName="routeId" />
        <mat-error *ngIf="form.get('routeId').hasError('maxlength')">
          Can't be longer than 25 characters
        </mat-error>
      </mat-form-field>
    </div>
    <!-- <div class="drawer-row">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        floatLabel="always">
        <mat-label>Route Name</mat-label>
        <input
          name="routeLongName"
          matInput
          placeholder="Route Name"
          aria-label="Route Name"
          formControlName="routeLongName" />
        <mat-error *ngIf="form.get('routeLongName').hasError('maxlength')">
          Can't be longer than 255 characters
        </mat-error>
      </mat-form-field>
    </div> -->
    <div class="drawer-row">
      <mat-checkbox formControlName="loop">Loop Service</mat-checkbox>
      <mat-icon matTooltip="Cannot be changed once service is created"
        >error_outline</mat-icon
      >
    </div>
  </form>
</div>
<div mat-dialog-actions fxLayoutAlign="end center" class="mar-top-10">
  <button mat-button (click)="onCloseModal()">Cancel</button>
  <button
    mat-raised-button
    type="button"
    color="primary"
    (click)="onSave()"
    class="float-right"
    [disabled]="!form.valid || isSubmitLoading">
    Create Service
  </button>
</div>
